module.exports = __webpack_public_path__ + "static/media/icon_163.7bd310f0.svg";